"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _inline_svg = _interopRequireDefault(require("./inline_svg.proptypes"));
var _inline_svg2 = require("./inline_svg.utils");
/* eslint-disable max-len */

const PoolsideBar = props => {
  const {
    fontSize,
    themeColor,
    ...restProps
  } = props;
  const theme = _react.default.useContext(_styledComponents.ThemeContext);
  const {
    sizeStyles,
    colorStyles
  } = (0, _inline_svg2.parseStyles)({
    fontSize,
    themeColor
  }, theme);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, sizeStyles, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none"
  }, restProps), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 3V5L14.5 14V19H19.5V21H7.5V19H12.5V14L4.5 5V3H22.5ZM7.15997 5.00002L8.92997 7.00002H18.07L19.85 5.00002H7.15997Z",
    fill: "#212124"
  }, colorStyles)), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    d: "M8.17 16C8.73 16 8.95 15.87 9.32 15.64C9.61702 15.4657 10.5 15 10.5 15.1184V17.2741C10.4552 17.3009 10.4089 17.3296 10.36 17.36L10.3473 17.3674C9.88862 17.6367 9.26985 18 8.17 18C7.06 18 6.44 17.63 5.99 17.36C5.62 17.13 5.39 17 4.84 17C4.29 17 4.06 17.13 3.69 17.36C3.23 17.63 2.65 18 1.5 18V16C2.06 16 2.28 15.87 2.65 15.64C3.11 15.37 3.73 15 4.84 15C5.95 15 6.57 15.37 7.02 15.64C7.39 15.87 7.61 16 8.17 16Z",
    fill: "#212124"
  }, colorStyles)), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    d: "M7.02 11.14C7.39 11.37 7.61 11.5 8.17 11.5C8.40021 11.5 8.57297 11.478 8.72231 11.4362L10.0642 13.0291C9.63424 13.2624 9.05942 13.5 8.17 13.5C7.06 13.5 6.44 13.13 5.99 12.86C5.62 12.63 5.39 12.5 4.84 12.5C4.29 12.5 4.06 12.63 3.69 12.86C3.23 13.13 2.65 13.5 1.5 13.5V11.5C2.06 11.5 2.28 11.37 2.65 11.14C3.11 10.87 3.73 10.5 4.84 10.5C5.95 10.5 6.57 10.87 7.02 11.14Z",
    fill: "#212124"
  }, colorStyles)), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    d: "M1.5 7.00004C2.06 7.00004 2.28 6.87004 2.65 6.64004C2.99651 6.43665 3.4338 6.17653 4.10294 6.06055L6.17796 8.47118C6.11185 8.43311 6.04944 8.3957 5.99 8.36004C5.62 8.13004 5.39 8.00004 4.84 8.00004C4.29 8.00004 4.06 8.13004 3.69 8.36004C3.23 8.63004 2.65 9.00004 1.5 9.00004V7.00004Z",
    fill: "#212124"
  }, colorStyles)));
};
PoolsideBar.propTypes = _inline_svg.default.propTypes;
PoolsideBar.defaultProps = _inline_svg.default.defaultProps;
var _default = exports.default = PoolsideBar;